import React, { useState } from 'react'
import { Classes, Dialog, InputGroup } from '@blueprintjs/core'
import { Flex, Icon, Toaster } from '@ui'
import api, { ISpaceCapacity } from '@api'
import { ApolloError } from 'apollo-client'
import useFloor from '@providers/mapProvider/floorProvider/provider'
import css from './capacitySection.module.scss'
import { EvoGhostButton, EvoButton } from '@ui/buttons/EvoButton'
import { Button } from '@runeffective/evo-design-system'

export interface CapacitySectionPopupDialogProps {
  setIsCapacityOpen: (para: boolean) => void
  isCapacityOpen: boolean
  selectedSpaces: string[]
}

export default function CapacitySectionPopup({
  setIsCapacityOpen,
  isCapacityOpen,
  selectedSpaces,
}: CapacitySectionPopupDialogProps) {
  const [btnDisabled, setBtnDisabled] = useState(true)
  const [selectedValue, setSelectedValue] = useState('0')
  const floor = useFloor()

  function resetState() {
    setBtnDisabled(true)
    setSelectedValue('0')
  }

  function onClickSubmit() {
    const data: ISpaceCapacity[] | { capacity: number; id: string }[] = []
    selectedSpaces.forEach(function (space) {
      data.push({ capacity: parseFloat(selectedValue), id: space })
    })

    api.space
      .updateSpacez(data)
      .then((usageTypes) => {
        Toaster.success({ message: 'Capacity updated successfully' })
        floor.reloadMap?.()
        setIsCapacityOpen(false)
      })
      .catch((error: ApolloError) => {
        Toaster.fail({ error })
      })
    resetState()
  }

  return (
    <>
      <Dialog
        style={{ paddingBottom: '0px' }}
        isOpen={isCapacityOpen}
        className={css.dialogWidth}
        transitionDuration={200}
        isCloseButtonShown={true}
        canOutsideClickClose={false}
        onClose={() => {
          setIsCapacityOpen(false)
          resetState
        }}
      >
        <div className={css.empList}>
          <Button
            style={{ position: 'absolute', top: '5px', right: '10px' }}
            aria-label="single icon button"
            onClick={() => {
              setIsCapacityOpen(false)
              resetState()
            }}
            size="default"
            layout="borderless"
          >
            <Icon name="close" />
          </Button>

          <div>
            <div className={css.dialogHeader}>Assigned Capacity</div>
          </div>
          <div>
            <div className={css.labelText}>
              Set capacity for each of the selected spaces. After completing this action, all the
              selected spaces will have the same capacity.
            </div>
            <div className={css.paddingTop}>
              <InputGroup
                value={selectedValue}
                type="number"
                className={css.inputWidth}
                onChange={(data) => {
                  setBtnDisabled(false)
                  setSelectedValue(data.target.value)
                  if (data.target.value == '') {
                    setSelectedValue('0')
                  }
                }}
              />
            </div>
          </div>
          <div className={css.paddingTop}>
            <div className={Classes.DIALOG_FOOTER} style={{ marginTop: 10 }}>
              <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                <Flex style={{ gap: '8px' }} direction="row" justify="space-between">
                  <Button
                    layout="borderless"
                    onClick={() => {
                      setIsCapacityOpen(false)
                      resetState()
                    }}
                    size="default"
                  >
                    Cancel
                  </Button>
                  <Button
                    disabled={btnDisabled}
                    layout="primary"
                    onClick={() => onClickSubmit()}
                    size="default"
                  >
                    Update
                  </Button>
                </Flex>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  )
}
